import axios from "axios";
import Vue from "vue";
import {
  applyAuthTokenInterceptor,
  clearAuthTokens,
  getAccessToken,
  getRefreshToken,
  isLoggedIn,
  setAuthTokens,
} from "axios-jwt";

import { API_URL } from "@/services/index";
import AuthService from "@/services/authentication";
import { errorHandler } from "@/router/utils";

export const http = axios.create({ baseURL: API_URL });

export const refreshToken = (refresh) => {
  return axios
    .post(
      `${API_URL}auth/refresh`,
      {
        refresh_token: refresh,
      },
      {
        headers: { Authorization: "Bearer " + getAccessToken() },
      }
    )
    .then((response) => response.data.access_token);
};

applyAuthTokenInterceptor(http, { requestRefresh: refreshToken });

const onOk = (response) => response;

const onError = (error) => {
  // Return any error which is not due to authentication back to the calling service
  if (error && error.response && error.response.status !== 401) {
    return Promise.reject(error);
  }

  const config = error.config;

  // eslint-disable-next-line no-unreachable
  if (!isLoggedIn()) {
    return Promise.reject(error);
  }

  // Logout user if token refresh didn't work or user is disabled
  if (error.config && error.config.url.endsWith("auth/refresh")) {
    AuthService.logout();
    if (Vue.options.router) {
      Vue.options.router.push("/login").catch(errorHandler);
    }
    return Promise.reject(error);
  }

  // Try request again with new token
  return new Promise((resolve, reject) => {
    AuthService.refreshToken(getRefreshToken())
      .then((response) => {
        setAuthTokens({
          accessToken: response.data.access_token,
          refreshToken: getRefreshToken(),
        });

        return http.request(config).then((response) => resolve(response));
      })
      .catch((e) => {
        clearAuthTokens();
        if (Vue.options.router) {
          Vue.options.router.push("/login").catch(errorHandler);
        }

        reject(e);
      });
  });
};

http.interceptors.response.use(onOk, onError);
